import script from "./AppointmentconfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentconfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentconfirmView.vue?vue&type=style&index=0&id=0f408ece&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f408ece"]])

export default __exports__